import { Input } from '@chakra-ui/react';
import useOrder from '@hooks/useOrder';
import { myInfoSelector } from '@stores/myInfo';
import { ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhoneAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';

export default function Phone() {
  const { updateOrderInfo } = useOrder();
  const { phone } = useSelector(myInfoSelector);
  const { t } = useTranslation('store');
  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const _replace = value.replace(/[^0-9]+/g, '');
    e.target.value = _replace;
    updateOrderInfo({ userPhone: _replace || '' });
  };
  useEffect(() => {
    updateOrderInfo({ userPhone: phone || '' });
  }, [phone]);
  return (
    <section className="flex flex-col gap-[6px] items-center">
      <div className="flex items-center gap-[6px]">
        <div>
          <FaPhoneAlt />
        </div>
        <span className="font-bold text-lg">{t('cell_phone_label')}</span>
      </div>
      <Input
        onInput={handlePhoneChange}
        type="tel"
        variant="filled"
        pattern="^((010|011|016)\d{8})$"
        defaultValue={phone && phone.replace(/[^0-9]+/g, '')}
        minLength={10}
        maxLength={11}
        placeholder={'ex) 01012341234'}
        textAlign="center"
      />
    </section>
  );
}
